import {observer} from "mobx-react";
import React, { ReactChild,ReactNode } from "react";
import "./index.less"
import {Spin} from "antd";


interface IProps{
    title:string,
    children:ReactChild,
    className?:string,
    width?:string,
    more?:ReactNode,
    titleLoading?:boolean,
}
const MyCard = ({title,children,className,width,more,titleLoading}: IProps) => {
    return  <div className={`myth-card ${className?className:''}`} style={{width:width?width:"100%"}}>
        <div className='myth-card-title'>{titleLoading?<Spin size="large"/>:<><span className="card-title">{title}</span>{more}</>}</div>
        <div className='myth-card-content'>{children}</div>
    </div>
};
const MythCard = observer(MyCard);
export default MythCard;